module.exports = __webpack_public_path__ + "static/media/left.532229d2.png";